import "core-js/stable";
import "regenerator-runtime/runtime";

import { Power2, gsap } from "gsap";

import { Scroll } from './_app/cuchillo/scroll/Scroll';
import { ScrollItem__Projects } from './scroll/ScrollItem__Projects';


import { Accessibility } from './_app/cuchillo/core/Accessibility';
import { Basics, isDebug, isTouch } from './_app/cuchillo/core/Basics';
import EventDispatcher from './_app/cuchillo/core/EventDispatcher';
import { Interaction, MrInteraction } from './_app/cuchillo/core/Interaction';
import { GetBy } from "./_app/cuchillo/core/Element";
import { Metrics } from './_app/cuchillo/core/Metrics';
import { Statics } from './_app/cuchillo/utils/Statics';
import Keyboard from './_app/cuchillo/core/Keyboard';

import LoaderController from './_app/cuchillo/loaders/LoaderController';
import PagesLoader from './_app/cuchillo/loaders/PagesLoader';
import MediaLoader from './_app/cuchillo/loaders/MediaLoader';

import { ControllerPage } from './_app/cuchillo/pages/ControllerPage';
import Page from './_app/cuchillo/pages/Page';
import Default from './pages/Default';
import Home from './pages/Home';
import Information from './pages/Information';
import Projects from './pages/Projects';
import Legal from './pages/Legal';
import NoScroll from './pages/NoScroll';
import Page404 from './pages/Page404';

import BG from './_app/cuchillo/layout/Background';
import InterfaceCanvas from './_app/cuchillo/layout/InterfaceCanvas';
import Header from './layout/Header';
import Loading from './layout/Loading';
// import ScrollTop from './layout/ScrollTop';
import Wrap from './layout/Wrap';

import { ControllerWindow } from './_app/cuchillo/windows/ControllerWindow';
import Win from './_app/cuchillo/windows/Window';
import Preloader from "./layout/Preloader";

import Language from "./_app/cuchillo/utils/Language";
import CMP from "./windows/Cmp";
import Guides from "./_app/cuchillo/utils/Guides";
import { Sizes } from "./_app/cuchillo/core/Sizes";
import Logo from "./layout/Logo";

import WebGLSketch from "./_app/cuchillo/3D/WebGLSketch";
import CircleSlider from "./3D/CircleSlider";
import TexturesController from "./_app/cuchillo/3D/TexturesController";
import RedEye from "./3D/RedEye";
import Scene from "./3D/Scene";
import { Functions } from "./_app/cuchillo/utils/Functions";


export default class Main {
  static stats;
  static lenis;
  static bgEye;
  static circleSlider;

  static init() {
    //gsap.ticker.fps(60);

    Basics.id = "alvpeerz_v003"; // ID para cookies   
    Language.init();

    TexturesController.isPreload = true;
    [...GetBy.selector("[data-preload-texture]")].map(item => {
      TexturesController.load({src:item.dataset.src});
    });

    Header.init();
    WebGLSketch.init();
    WebGLSketch.start();
    Functions.enableClock();

    Guides.init();
    Guides.add({
      cols:12,
      enabled:true,
      padding:Metrics.parseSize("6fpx"),
      gap:Metrics.parseSize("6fpx")
    });
    
        
    Metrics.init(() => Main.resize()); // Tamaños y resize
    Keyboard.enable(); // ESC para cerrar ventana
    Accessibility.init(); // Utils accesibilidad
    Statics.init(); // Si estamos en debug pinta un FPS counter
    Interaction.init({ ajax: true }) // Posiciones del cursor (Movimiento, click...), Acciones links, drag...
    ControllerWindow.init(); // Control ventanas

    BG.init(CMS_COLORS); // Control de paletas y color de fondo de pantallas. Automatico si añadimos un data-palette='loquesea' en el div con data-page
    InterfaceCanvas.init(); // Canvas de interface, se usa con Cursor
    CMP.init(); // Checkea y saca el aviso de cookies
    Logo.init();
   
    LoaderController.add(new PagesLoader()); // Carga/Precarga de paginas HTML
    LoaderController.add(new MediaLoader()); // Carga/Precarga de imgs
    LoaderController.onComplete = () => {
      Main.start();
      Main.setup()
    };
    
    Scene.init();
    Preloader.init(()=> LoaderController.init());
  }

  static start() {
    this.bgEye = new RedEye({dom:GetBy.id("scene-three")});
    this.circleSlider = new CircleSlider(GetBy.id("full-slider"));
     // LOOP
     gsap.ticker.lagSmoothing(0);
     if (isDebug) {
      gsap.ticker.add((time) => { Main.loopDebug(time); });
    } else {
      //this.setWorker();
      this.doCuchilloInfo();
      gsap.ticker.add((time) => { Main.loop(time); });
    }
    
    Scene.add(this.bgEye);
    Scene.add(this.circleSlider);

    this.bgEye.init();
  }

  static async setup() {
    // Si existe la promise, esperamos; si no hay video_data en _site, continuamos
    if (window.__videosDataReady) {
      try {
        await window.__videosDataReady;
      } catch(e) {
        // Ya manejado en el inline script, pero por seguridad
        window.__videosData = {};
      }
    }

    Main.setupEvents();
    ControllerPage.init(Wrap.mainholder);
  }

  static setupEvents() {
    EventDispatcher.addEventListener(Page.ON_SHOW, () => {
      //Cursor.start();
      Loading.stop();
    });
    EventDispatcher.addEventListener(Page.ON_HIDE, () => {
      //Cursor.hide();
    });
    EventDispatcher.addEventListener(Page.ON_HIDE_END, () => {
      Loading.start();
    });

    EventDispatcher.addEventListener(Win.ON_HIDE, () => { Scroll.start(); });
    EventDispatcher.addEventListener(Win.ON_SHOW, () => { Scroll.stop(); });
  }

  static resize() {
    Logo.resize();
    Header.resize();
    Guides.resize();
    InterfaceCanvas.resize();
    BG.resize();
    ControllerPage.resize();
    WebGLSketch.resize();

    if(this.circleSlider) this.circleSlider.resize();
    if(this.bgEye) this.bgEye.resize();
  }

  static loop(time) {
    Scroll.loop(time);
    
    ControllerPage.loop();

    //this.bgEye.loop();
    this.circleSlider.loop();

    BG.loop();
    Header.loop();
    //Guides.loop();
    InterfaceCanvas.loop();
    Logo.loop();
    WebGLSketch.loop();
  }

  static loopDebug(time) {
    Statics.begin();
    this.loop(time);
    Statics.end();
  }

  static doCuchilloInfo() {
    console.log('%cby Cuchillo', 'background: #000; color: #bada55; padding:25px 100px;');
    console.log('⟶ http://somoscuchillo.com');
    console.log('⟶ https://www.instagram.com/_cuchillo');
    console.log('⟶ https://twitter.com/somoscuchillo');
    console.log('⟶ https://twitter.com/mr__corrales');
    console.log('');
    console.log('Gsap by Greenshock');
    console.log('⟶ https://greensock.com');
    console.log('');
    console.log('Font: Fraktion Mono by Pangram Pangram');
    console.log('⟶ https://pangrampangram.com/products/fraktion');
    console.log('');
    console.log('SVGOMG');
    console.log('⟶ https://jakearchibald.github.io/svgomg/');
    console.log('');
    console.log('Favicon Generator');
    console.log('⟶ https://realfavicongenerator.net');
  }

  static setWorker() {
    if ('serviceWorker' in navigator && !isDebug) {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then(function () { });
    }
  }
}

if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
  Main.init();
} else {
  document.addEventListener('DOMContentLoaded', Main.init);
}
